module.exports = __webpack_public_path__ + "static/media/ops1.png.dbd86759.jpg";